import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { LionEngine } from '../engine/io-engine';
import { IoniScriptManager } from '../engine/io-manager';
import { FunctionUtil } from '../functions/function-util';
import { AuthService } from '../onedrive/auth.service';
import { PubComponent } from '../published-lionscript/pub-component';
import { PubComponentListener } from '../published-lionscript/pub-component-listener';
import { FileElement } from './model/element';
import { FileService } from './service/file.service';



@Component({
  selector: 'simple-file-browser',
  templateUrl: './fb.component.html',
  styleUrls: ['./fb.component.css']
})
export class FBComponent implements OnInit, PubComponent {


  public fileElements: Observable<FileElement[]>;
  pathFunction: any;

  constructor(public fileService: FileService) { }
  data: any;
  listener: PubComponentListener;
  resolveFunction: any;
  title: string;
  @Input()
  path = '';
  @Input()
  mode = '';
  root;
  rootElement;
  @Output()
  fileSelected = new EventEmitter<FileElement>();
  @Output()
  currentPathE = new EventEmitter<String>();
  currentRoot: FileElement;
  currentPath: string;
  canNavigateUp = false;
  listenerFunction;
  cmdFunction;
  height = `100%`;
  width = '100%';
  backgroundcolor = 'white';
  folderAddedPath;
  filterFunction;
  // Extensions this browser never lists. A VCF sits next to the design it was called
  // from and is read by the tools, not opened by hand, so showing it only adds noise
  // to the folder. Lower-case, no leading dot; set per browser from lionscript.
  hideExtensions: string[] = [];
  // Exceptions to the above, matched the same way and tested FIRST. A suffix rule is
  // blunt: hiding 'json' also hides the .karyotype.json files saved before that
  // extension was shortened, and those are still openable from here. The exception is
  // the longer, more specific suffix, which is how it should win.
  keepExtensions: string[] = [];
  folderDialogFunction;
  folderPath;
  fileclickFunction;
  rootPath;
  keyDrive = 'default';
  canAddFolder = false;
  canWriteListenerFunction;
  columns = 5;
  showSearch = true;
  server = null;
  filetype = '*';
  user = null;





  cmd(c) {
    if (this.cmdFunction) {
      this.cmdFunction(c)
    }
  }


  init(ionEngine: IoniScriptManager): string {
    if (this.data['height'] != null)
      this.height = this.data['height']
    if (this.data['root']) {
      this.rootPath = this.data['root']
    }

    if (this.data['filetype'])
      this.filetype = this.data['filetype']
    if (this.data['fileType'])
      this.filetype = this.data['fileType']


    if (this.data['drive'] != null) {
      this.keyDrive = this.data['drive']
    }
    if (this.data['user'] != null) {
      this.user = this.data['user']
    }
    if (this.data['server'] != null) {
      this.server = this.data['server']
    }
    if (this.data['showSearch'] != null) {
      this.showSearch = this.data['showSearch']
    }
    if (this.data['ionfunction.openfile']) {
      this.listenerFunction = LionEngine.ionfunctions[this.data['ionfunction.openfile']]
    }

    if (this.data['ionfunction.cmd']) {
      this.cmdFunction = LionEngine.ionfunctions[this.data['ionfunction.cmd']]
    }
    if (this.data['ionfunction.canWriteToFolder']) {
      this.canWriteListenerFunction = LionEngine.ionfunctions[this.data['ionfunction.canWriteToFolder']]
    }
    if (this.data['ionfunction.fileClick']) {
      this.fileclickFunction = LionEngine.ionfunctions[this.data['ionfunction.fileClick']]
    }
    if (this.data['ionfunction.path']) {
      this.pathFunction = LionEngine.ionfunctions[this.data['ionfunction.path']]
    }
    if (this.data["ionfunction.folderadded"]) {
      // ionfunction.folderadded
      this.folderAddedPath = LionEngine.ionfunctions[this.data['ionfunction.folderadded']]
    }
    if (this.data["filterFunction"]) {
      this.filterFunction = LionEngine.ionfunctions[this.data['filterFunction']]
    }
    if (this.data['hideExtensions']) {
      // Accepts 'vcf', '.vcf', or a list of either.
      const raw = this.data['hideExtensions'];
      this.hideExtensions = (Array.isArray(raw) ? raw : [raw])
        .map((e: any) => String(e == null ? '' : e).trim().toLowerCase().replace(/^\./, ''))
        .filter((e: string) => e.length > 0);
    }
    if (this.data['keepExtensions']) {
      const rawK = this.data['keepExtensions'];
      this.keepExtensions = (Array.isArray(rawK) ? rawK : [rawK])
        .map((e: any) => String(e == null ? '' : e).trim().toLowerCase().replace(/^\./, ''))
        .filter((e: string) => e.length > 0);
    }
    if (this.data["columns"]) {
      this.columns = this.data['columns']
    }
    if (this.data['folderDialogFunction']) {
      this.folderDialogFunction = LionEngine.ionfunctions[this.data['folderDialogFunction']]
    }
    return '';
  }


  async refresh() {
    // priva  te map = new Map<string, FileElement>();
    this.fileService.map = new Map<string, FileElement>();

    this.load(this.currentRoot);

    if (this.rootPath) {
      let host = window['env']['apiUrl'];
      if (this.server) {
        host = this.server
      }



      // console.log(" loading... " + host + '/get-folder?path=' + this.rootPath)
      // alert ( ' this.keydrive ' + this.keyDrive + " this.rootpath " + this.rootPath )
      let rf = await FunctionUtil.GETJSON(host + '/get-folder?key=' + this.keyDrive + '&path=' + this.rootPath, this.user)
      this.root = rf;
      // if (rf['path'].startsWith('/')) {
      //   rf['path'] = rf['path'].substring(1)
      // }
      // 
      // let rootE = { id: this.root.id, name: rf['name'], path: rf['path'], isFolder: true, parent: 'root' };
      // this.fileService.add(rootE);
      await this.load(this.currentRoot)
      this.updateFileElementQuery();
    }
  }

  async ngOnInit() {
    if (this.rootPath) {
      let host = window['env']['apiUrl'];
      if (this.server) {
        host = this.server
      }
      let rf = await FunctionUtil.GETJSON(host + '/get-folder?key=' + this.keyDrive + '&path=' + this.rootPath, this.user)
      this.root = rf;
      let rootE = { id: this.root.id, name: rf['name'], path: rf['path'], isFolder: true, parent: 'root' };
      // this.fileService.add(rootE);
      await this.load(rootE)
      this.updateFileElementQuery();
    }
  }


  async load(parentNode) {
    this.currentRoot = parentNode;
    let host = window['env']['apiUrl'];
    if (this.server) {
      host = this.server
    }

    // if (!parentNode) {
    //   parentNode = {
    //     path: '/'
    //   }
    // }

    let fol = await FunctionUtil.GETJSON(host + '/get-nodes?key=' + this.keyDrive + '&path=' + parentNode.path, this.user)
    let nodes = fol['values'];
    if (nodes && nodes.length > 0) {
      for (let n of nodes) {
        // Folders are never hidden by extension: a folder called "batch.vcf" is
        // somewhere the user can still navigate into.
        if (!n['isFolder'] && this.isHidden(n['name'])) {
          continue;
        }
        if (this.filterFunction && this.filterFunction(n)) {
          let pnode = await this.fileService.add(n);
        } else {
          let pnode = await this.fileService.add(n);

        }
      }
    }
    this.updateFileElementQuery();
  }
  isHidden(name: string): boolean {
    if (!this.hideExtensions || this.hideExtensions.length === 0) { return false; }
    const n = String(name == null ? '' : name).toLowerCase();
    const ends = (suffix: string) => n.length > suffix.length && n.substring(n.length - suffix.length) === suffix;
    // An exception wins over a hide rule, because it is the more specific statement about
    // the same name: '.karyotype.json' is kept even though 'json' is hidden.
    for (const keep of (this.keepExtensions || [])) {
      if (ends('.' + keep)) { return false; }
    }
    // Matched as a SUFFIX, not as the text after the last dot, so a compound extension
    // works: 'vcf.gz' has to hide variants.vcf.gz, and the last dot there only says 'gz'.
    // The length test is what keeps a dotfile out of it -- '.vcf' ends with '.vcf' but is
    // a name in its own right, with nothing in front of the extension.
    for (const ext of this.hideExtensions) {
      const suffix = '.' + ext;
      if (n.length > suffix.length && n.substring(n.length - suffix.length) === suffix) {
        return true;
      }
    }
    return false;
  }

  async addFolder(folder: { name: string, _id: string }) {
  }
  removeElement(element: FileElement) {
    this.fileService.delete(element.id);
    this.updateFileElementQuery();
  }
  async openFile(file) {
    alert(' test ' + file)
  }

  navigateToFolderNamed(name: string) {
    if (!name || name.length <= 0) {
      this.navigateUp()
    } else {
      let sub = this.fileElements.subscribe((fileElementArray) => {
        for (let fileElement of fileElementArray) {
          if (fileElement.isFolder && fileElement.name === name) {
            this.navigateToFolder(fileElement);
            this.canNavigateUp = true;
          }
        }
      })
      sub.unsubscribe();
    }
  }
  async navigatePath(path) {
    const folders = path.split('/').filter(folder => folder !== '');
    for (const folder of folders) {
      await this.navigateToFolderNamed(folder);
      await this.refresh();

    }
  }

  fileClick(element: FileElement) {
    this.fileSelected.emit(element);
    this.currentPathE.emit(this.currentPath)
    // console.log(" file : " + JSON.stringify(element));
    // console.log(" file : " + this.currentPath);
    if (this.pathFunction)
      this.pathFunction(element);
    if (!element.isFolder && this.fileclickFunction)
      this.fileclickFunction(element);
  }

  async navigateToFolder(element: FileElement) {
    console.log(" EVENT : " + JSON.stringify(element));
    this.currentRoot = element;
    await this.updateFileElementQuery();
    if (this.currentPath === null || this.currentPath == undefined || this.currentPath.length <= 0) {
      this.currentPath = '/' + element.name
    } else
      this.currentPath = this.pushToPath(this.currentPath + '/', element.name);
    if (this.currentPath.endsWith('/')) {
      this.currentPath = this.currentPath.substring(0, this.currentPath.length - 1)
    }
    if (this.pathFunction) {
      this.pathFunction(this.currentPath)
    }
    this.load(element)
    this.currentPathE.emit(this.currentPath)
    this.canNavigateUp = true;
    if (!element.id) {
      return;
    }
  }

  async navigateUp() {
    let path = this.currentRoot.path;

    if (path.endsWith('/')) {
      path = path.substring(0, path.length - 1)
    }
    const segments = path.split('/');
    const nodes = segments.filter(segment => segment.length > 0);
    if (nodes.length === 1) {
      this.canNavigateUp == false;

    } else {
      path = path.substring(0, path.lastIndexOf('/') + 1)
    }
    this.rootPath = path;
    // alert ( this.rootPath );
    this.currentPath = this.currentPath.substring(0, this.currentPath.lastIndexOf('/'))
    let host = window['env']['apiUrl'];
    if (this.server) {
      host = this.server
    }
    let rf = await FunctionUtil.GETJSON(host + '/get-folder?key=' + this.keyDrive + '&path=' + this.rootPath, this.user)
    this.root = rf;
    if (rf['name'].startsWith('/')) {
      rf['name'] = rf['name'].substring(1)
    }


    if (this.pathFunction) {
      this.pathFunction(this.currentPath)
    }

    let rootE = { id: this.root.id, name: rf['name'], path: rf['path'], isFolder: true, parent: 'root' };
    // this.fileService.add(rootE);
    await this.load(rootE)
    this.updateFileElementQuery();





  }

  moveElement(event: { element: FileElement; moveTo: FileElement }) {


    this.fileService.update(event.element.id, { parent: event.moveTo.id });
    this.updateFileElementQuery();
  }

  renameElement(element: FileElement) {
    console.log(element);
    this.fileService.update(element.id, { name: element.name });
    this.updateFileElementQuery();
  }

  async updateFileElementQuery() {
    this.fileElements = this.fileService.queryInFolder(this.currentRoot ? this.currentRoot.id : 'root');
  }

  pushToPath(path: string, folderName: string) {
    if (path && path.length > 0) {
      path = path.trim();
      folderName = folderName.trim();
      let p = path ? path : '';
      p += `${folderName}/`;
      return p;
    } else {
      return `${folderName}/`;
    }
  }

  popFromPath(path: string) {
    let p = path ? path : '';
    let split = p.split('/');
    split.splice(split.length - 2, 1);
    p = split.join('/');
    return p;
  }
}
